import axios from "axios";

const APIService = {
  getServerUrl() {
    try {
      return process.env.REACT_APP_COOP_AUTH_API;
    } catch (error) {
      this.handleError(error);
    }
  },

  getCoopToken() {
    try {
      let coopToken = sessionStorage.getItem("coopToken");
      return coopToken;
    } catch (error) {
      this.handleError(error);
    }
  },

  storeCoopToken(token) {
    try {
      sessionStorage.setItem("coopToken", token);
    } catch (error) {
      this.handleError(error);
    }
  },

  async login(credentials) {
    try {
      let SERVER_URL = this.getServerUrl();

      let response = await axios.post(`${SERVER_URL}/auth/login`, credentials);
      this.storeCoopToken(response.data.token);

      return response.data;
    } catch (error) {
      this.handleError(error);
      throw error; // Re-throw error after handling it
    }
  },

  async verifyCode(data, token) {
    try {
      let SERVER_URL = this.getServerUrl();

      const config = {
        headers: {
          Authorization: token,
        },
      };
      let response = await axios.post(`${SERVER_URL}/auth/verifyCode`, data, config);
      this.storeCoopToken(response.data.token);

      return response.data;
    } catch (error) {
      this.handleError(error);
      throw error; // Re-throw error after handling it
    }
  },

  async withdrawalRequest(data) {
    try {
      let SERVER_URL = this.getServerUrl();

      const config = {
        headers: {
          Authorization: this.getCoopToken(),
        },
      };
      let response = await axios.post(`${SERVER_URL}/finance/bizDevPayment`, data, config);

      return response.data;
    } catch (error) {
      this.handleError(error);
      throw error; // Re-throw error after handling it
    }
  },

  handleError(error) {
    console.error('APIService error:', error);
  },
};

export default APIService;
